<template>
  <div class="submitter-details">
    <Typography v-if="submitter" variant="body-2">Submitter: {{ submitter }}</Typography>
    <Typography v-if="additionalClaimants && additionalClaimants.length > 0" variant="body-2"
      >Additional Claimants: {{ additionalClaimantNames }}</Typography
    >
    <Typography v-if="claim.dealerName" variant="body-2"
      >Dealer Name: {{ claim.dealerName }}</Typography
    >
  </div>
</template>

<script>
import Typography from "@/components/generic/Typography.vue";
import { mapState } from "vuex";

export default {
  name: "ClaimSubmitterDetails",
  components: {
    Typography,
  },
  computed: {
    ...mapState(["userProfile"]),
    submitter() {
      return this.claim?.claimDependencies?.submitterName || this.userProfile.displayName;
    },
    additionalClaimants() {
      return this.claim?.claimDependencies?.additionalClaimants || [];
    },
    additionalClaimantNames() {
      return this.additionalClaimants.map((claimant) => claimant.name).join(", ");
    },
  },
  props: {
    claim: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped>
.submitter-details {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
</style>
